import styled from 'styled-components';

import Button from 'components/shared/Button';
import ButtonGroup from 'components/shared/ButtonGroup';

import { Scenario, SCENARIOS } from './types';

type Props = {
  scenario: Scenario;
  isApproveEditMode?: boolean;
  onUnlink?: () => void;
  onApprove?: () => void;
  onDeny?: () => void;
  onRelink?: () => void;
  onApply?: () => void;
  onCancel?: () => void;
  hasChanges?: boolean;
};

export default function SlideoutFooter({
  scenario,
  isApproveEditMode,
  onUnlink,
  onApprove,
  onDeny,
  onRelink,
  onApply,
  onCancel,
  hasChanges,
}: Props) {
  if (scenario === SCENARIOS.REMOVE_INDIVIDUAL) {
    return null;
  }

  return (
    <FooterContainer>
      {scenario === SCENARIOS.UNLINK_TWO && (
        <Button variant='outline-danger' onClick={onUnlink}>
          Unlink Records
        </Button>
      )}

      {(scenario === SCENARIOS.APPROVE_MANY || scenario === SCENARIOS.APPROVE_TWO) && !isApproveEditMode && (
        <ButtonRow>
          <Button variant='outline-danger' onClick={onDeny}>
            Deny Match
          </Button>
          <Button onClick={onApprove}>Approve Match</Button>
        </ButtonRow>
      )}

      {scenario === SCENARIOS.APPROVE_MANY && isApproveEditMode && (
        <ButtonRow>
          <Button variant='ghost' onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onApply} disabled={!hasChanges}>
            Apply
          </Button>
        </ButtonRow>
      )}

      {scenario === SCENARIOS.UNLINKED && <Button onClick={onRelink}>Relink Records</Button>}
    </FooterContainer>
  );
}

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 24px;

  > button {
    width: 100%;
  }
`;

const ButtonRow = styled(ButtonGroup)`
  display: flex;
  gap: 12px;

  > button {
    flex: 1;
  }
`;
